import { Box } from '@mui/material'
import { motion, AnimatePresence } from 'framer-motion'
import classes from './global-hover-sidebar.module.scss'

interface HoverDrawerProps {
  isOpen: boolean
  position: 'left' | 'right'
  onMouseLeave: () => void
  children: React.ReactNode
}

const drawerVariants = {
  left: {
    hidden: { x: '-100%' },
    visible: { x: 0 },
  },
  right: {
    hidden: { x: '100%' },
    visible: { x: 0 },
  },
}
const HoverDrawer = ({
  isOpen,
  position,
  onMouseLeave,
  children,
}: HoverDrawerProps) => {
  const variants = drawerVariants[position]

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={`${classes['hover-drawer']} ${classes[`hover-drawer--${position}`]}`}
          initial="hidden"
          animate="visible"
          exit="hidden"
          variants={variants}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          onMouseLeave={onMouseLeave}
        >
          <Box sx={{ height: '100%' }}>{children}</Box>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default HoverDrawer
